// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".judgement-waiter-tab[data-v-318674ae]{position:relative}.judgement-waiter-tab .switch[data-v-318674ae]{width:70px}.judgement-waiter-tab .point[data-v-318674ae]{font-weight:700;font-size:20px}.judgement-waiter-tab .box-footer[data-v-318674ae]{padding:10px 0 0 0!important}.judgement-waiter-tab .box-footer .update-btn[data-v-318674ae]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
